const content = (
  <div>
    <p>
      Cette formation a été conçue sur mesure pour une petite structure
      spécialisée dans l’intégration de logiciels. Elle répond aux besoins
      spécifiques d’une équipe restreinte devant conjuguer organisation
      interne, management de proximité, relation client et coordination de
      prestataires.
    </p>
    <p>Formation sur mesure - Intra-entreprise</p>

    <h2>Public concerné</h2>
    <p>
      Dirigeants, responsables, managers ou collaborateurs amenés à participer
      à l’organisation et au pilotage d’une petite structure technique.
    </p>
    <p>Session réalisée : 2 apprenantes au sein d’une équipe de 3 personnes.</p>

    <h2>Prérequis</h2>
    <p>
      Aucun prérequis spécifique. Une connaissance de l’environnement
      professionnel de l’entreprise, de son fonctionnement et de ses principaux
      interlocuteurs est souhaitable afin de faciliter la mise en pratique des
      outils proposés.
    </p>

    <h2>Objectifs pédagogiques</h2>
    <ul>
      <li>Clarifier les rôles et responsabilités au sein d’une petite structure.</li>
      <li>Organiser et prioriser l’activité de l’équipe.</li>
      <li>Améliorer la communication interne et externe.</li>
      <li>Donner un feedback constructif.</li>
      <li>Déléguer de manière adaptée et favoriser l’autonomie.</li>
      <li>Piloter efficacement la relation client.</li>
      <li>Cadrer les demandes, délais et priorités.</li>
      <li>Organiser le travail avec des prestataires ou freelances.</li>
      <li>Utiliser des outils simples de suivi et de pilotage.</li>
    </ul>

    <h2>Programme</h2>
    <h2>Jour 1 - Poser les bases du management dans une petite structure</h2>
    <h3>1. Clarifier les rôles et responsabilités</h3>
    <ul>
      <li>Définir clairement qui fait quoi.</li>
      <li>Répartir les tâches et favoriser la co-construction.</li>
      <li>Mettre en place des rituels d’équipe.</li>
      <li>Organiser un reporting simple et adapté.</li>
    </ul>
    <h3>2. Communiquer avec impact et fluidité</h3>
    <ul>
      <li>Donner un feedback constructif.</li>
      <li>Organiser des points réguliers efficaces.</li>
      <li>Utiliser les outils collaboratifs adaptés : Slack, Notion, CRM.</li>
    </ul>
    <h3>3. Gérer efficacement la relation client</h3>
    <ul>
      <li>Adopter une posture managériale adaptée face aux clients.</li>
      <li>Cadrer les demandes.</li>
      <li>Négocier les délais.</li>
      <li>Prévenir et désamorcer les tensions.</li>
    </ul>

    <h2>Jour 2 - Manager pour faire grandir la structure</h2>
    <h3>4. Déléguer et responsabiliser dans une petite équipe</h3>
    <ul>
      <li>Mettre en place une délégation progressive.</li>
      <li>Définir un cadre clair.</li>
      <li>Renforcer l’autonomie et la confiance mutuelle.</li>
    </ul>
    <h3>5. Piloter l’activité et prioriser les chantiers</h3>
    <ul>
      <li>Définir et suivre des indicateurs simples.</li>
      <li>Prioriser les actions.</li>
      <li>Utiliser des méthodes agiles adaptées aux petites équipes : Kanban et OKR simplifiés.</li>
    </ul>
    <h3>6. Travailler avec des prestataires et freelances</h3>
    <ul>
      <li>Formaliser les attentes, livrables et délais.</li>
      <li>Assurer un suivi sans micro-management.</li>
      <li>Intégrer ponctuellement des ressources externes sans désorganiser l’équipe.</li>
    </ul>

    <h2>Méthodes pédagogiques</h2>
    <ul>
      <li>Apports méthodologiques.</li>
      <li>Échanges d’expériences.</li>
      <li>Ateliers pratiques.</li>
      <li>Études de situations réelles rencontrées dans l’entreprise.</li>
      <li>Mises en situation.</li>
      <li>Construction d’outils directement applicables dans l’activité professionnelle.</li>
    </ul>
    <h2>Livrables</h2>
    <ul>
      <li>Une boîte à outils managériale personnalisée.</li>
      <li>Un plan d’action opérationnel adapté à la structure.</li>
    </ul>
    <h2>Modalités d’évaluation</h2>
    <ul>
      <li>Positionnement initial.</li>
      <li>Grille de validation des acquis avant et après la formation.</li>
      <li>Exercices pratiques et mises en situation.</li>
      <li>Questionnaire de satisfaction à chaud à l’issue de la formation.</li>
    </ul>

    <h2>Durée et modalités</h2>
    <p>Durée : 2 jours - 15 heures (2 journées de 7 h 30).</p>
    <p>Format : présentiel ou distanciel.</p>
    <p>Langue : français.</p>
    <h2>Modalités et délais d’accès</h2>
    <p>Formation organisée sur demande, après analyse des besoins du commanditaire et des bénéficiaires. Le calendrier est défini en concertation avec l’entreprise selon les disponibilités respectives.</p>
    <p>Délai d’accès : à préciser selon la procédure réellement appliquée par NATELCO.</p>
    <h2>Tarif</h2>
    <p>Sur devis, après analyse des besoins et définition du périmètre de la prestation.</p>
    <h2>Accessibilité</h2>
    <p>Les besoins spécifiques liés à une situation de handicap sont étudiés en amont afin d’envisager les adaptations pédagogiques, matérielles ou organisationnelles nécessaires.</p>
    <p>Contact handicap / contact formation : Nathalie Levy.</p>
  </div>
);

export default content;
